module.exports = __webpack_public_path__ + "img/bottom_icon_pick_t.33b037cd.svg";